
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Testicular_neoplasm',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Testicular_neoplasm.vue